import React, {useState} from 'react';
import {Form, Formik} from 'formik';
import can from '../../../_common/components/Permissions/can';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {DataItem} from '../../../_common/components/DataItem/DataItem';
import {addReceiptToInvoice} from '../../_redux/invoicesActions';
import {useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';
import {Modal} from 'react-bootstrap';
import {Button} from 'react-bootstrap';

export function PopupAddReceipt({cellContent}) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);

  const {_id: invoiceID} = cellContent;
  let receiptID = '';

  const header = intl.formatMessage({
    id: 'invoices-popup-addReceipt-header',
    defaultMessage: 'Add receipt - '
  });
  const buttonOpenPopupLabel = intl.formatMessage({
    id: 'invoices-button-addReceipt',
    defaultMessage: 'Add receipt'
  });
  const labelSubmit = intl.formatMessage({
    id: 'invoices-popup-buttonSubmit',
    defaultMessage: 'Submit'
  });
  const labelCancel = intl.formatMessage({
    id: 'invoices-popup-buttonCancel',
    defaultMessage: 'Cancel'
  });

  const buttonClassName = `w-100 px-4 py-2 d-flex align-items-center justify-content-between text-nowrap font-size-lg 
  ${can('full', 'invoices') ? `` : `opacity-30`}`;

  return (
    <>
      <div
        className={buttonClassName}
        onClick={() => {
          if (can('full', 'invoices')) {
            handleShowModal()
          }
        }}
      >
        {buttonOpenPopupLabel}
        <img
          src={toAbsoluteUrl('/media/svg/Add-document_brandColor.svg')}
          alt="icon"
          className={'w-30px h-30px ml-2'}
        />
      </div>
      <Modal
        show={show}
        onHide={handleCloseModal}
      >
        <Modal.Body>
          <h3 className="card-title font-weight-bold text-dark text-center">
            {`${header} ${invoiceID}`}
          </h3>
          <div>
            <Formik
              initialValues={{receipt: receiptID}}
              onSubmit={() => null}
              enableReinitialize={true}
            >
              <Form>
                <DataItem
                  fieldId={'receipt'}
                  onChange={e => {
                    receiptID = e.target.value;
                  }}
                  inputContainerStyle={'w-75 mx-auto mb-12'}
                />
              </Form>
            </Formik>
          </div>
          <div className="d-flex justify-content-center">
            <Button
              className="btn btn-secondary btn-sm col-3 mx-3"
              onClick={() => {
                handleCloseModal();
              }}
            >
              {labelCancel}
            </Button>
            <Button
              className="btn btn-primary btn-sm col-3 mx-3 custom-send-button"
              onClick={() => {
                dispatch(addReceiptToInvoice(invoiceID, receiptID));
                handleCloseModal();
              }}
            >
              {labelSubmit}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default PopupAddReceipt;
